




































































import { Component } from 'vue-property-decorator'
import ViewBase from '@/utils/ViewBase'
import { setnewpassword, getuser } from '@/api/password'

@Component
export default class Main extends ViewBase {
  logging: any = false
  form: any = null
  channelManagerUserId = 0
  success = false
  expire = true
  type: any = ''
  title: any = '重置'

  created() {
    this.form = this.$form.createForm(this)
    this.init()
  }

  async init() {
    try {
      const res = await getuser({
        token: this.$route.params.token,
      })
      this.channelManagerUserId = res.data.channelManagerUserId
      this.type = this.$route.params.type
      if (this.type == 2) {
        this.title = '设置'
      }
    } catch (ex) {
      // this.handleError(ex)
      this.expire = false
    }
  }

  checkprice(rule: any, value: any, callback: any) {
    if (value == this.form.getFieldsValue().newPassword) {
      callback()
      return
    }
    callback('2次密码输入不一致')
  }

  goBack() {
    this.$router.push({
      name: 'login',
    })
  }
  async onSubmit(e: any) {
    e.preventDefault()
    const flag = await (this.form as any).validateFields()
    try {
      if (flag) {
        await setnewpassword({
          ...flag,
          userId: this.channelManagerUserId,
          token: this.$route.params.token,
        })
        this.success = true
      }
    } catch (ex) {
      this.handleError(ex)
    }
  }
}
